import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreDocumentsDataUseCase } from '@/core/domain/official-documents/usecases/storeDocuments.usecase';
import { OfficialDocumentsRepository } from '@/core/domain/official-documents/repositories/official-documents.repository';
import { OfficialDocumentsImplRepository } from './official-documents-imp.repository';

const StoreDocumentsDataUseCaseFactory = (
    officialDocumentsRepository: OfficialDocumentsRepository,
) => new StoreDocumentsDataUseCase(officialDocumentsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: StoreDocumentsDataUseCase,
            useFactory: StoreDocumentsDataUseCaseFactory,
            deps: [OfficialDocumentsRepository],
        },
        {
            provide: OfficialDocumentsRepository,
            useClass: OfficialDocumentsImplRepository,
        },
    ],
})
export class OfficialDocumentsDataModule {}
